import { render, staticRenderFns } from "./ProfileEmailPage.vue?vue&type=template&id=32ef3b9f&scoped=true&"
import script from "./ProfileEmailPage.vue?vue&type=script&lang=js&"
export * from "./ProfileEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef3b9f",
  null
  
)

export default component.exports